module.exports = __webpack_public_path__ + "ecd9db313ec0c8e0c6c43bb6e54540e1.png";